export const getDefaultApiUrl = (): string => process.env.REACT_APP_API_URL as string;
